"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledChildren = exports.StyledPrimaryContent = exports.StyledDropdownButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ProtoButton = _interopRequireDefault(require("../ProtoButton"));

var _dropdown = require("../../../styles/2_commonComponentStyles/dropdown");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledDropdownButton = (0, _styledComponents.default)(_ProtoButton.default).withConfig({
  displayName: "DropdownButtonstyles__StyledDropdownButton",
  componentId: "megqc3-0"
})(["", " ", ""], _dropdown.dropdownItem, _dropdown.dropdownItemThemes);
exports.StyledDropdownButton = StyledDropdownButton;

var StyledPrimaryContent = _styledComponents.default.div.withConfig({
  displayName: "DropdownButtonstyles__StyledPrimaryContent",
  componentId: "megqc3-1"
})(["text-align:left;display:flex;width:100%;"]);

exports.StyledPrimaryContent = StyledPrimaryContent;

var StyledChildren = _styledComponents.default.div.withConfig({
  displayName: "DropdownButtonstyles__StyledChildren",
  componentId: "megqc3-2"
})(["width:100%;margin-left:", ";position:relative;"], function (props) {
  return props.leftIcon ? '.75rem' : 0;
});

exports.StyledChildren = StyledChildren;